import { useEffect, useState } from "react";
import { X } from "lucide-react";
import EmojiPicker from "./EmojiPicker";

const COLOR_OPTIONS = [
  "#FFB627", "#FF6B47", "#FF8A5B", "#FFD23F",
  "#6FAE6D", "#5AA9E6", "#F38BA8", "#C58A6B",
];

export default function CategoryEditor({ open, initial, onClose, onSave }) {
  const [name, setName] = useState("");
  const [emoji, setEmoji] = useState("📁");
  const [color, setColor] = useState(COLOR_OPTIONS[0]);

  useEffect(() => {
    if (!open) return;
    setName(initial?.name || "");
    setEmoji(initial?.emoji || "📁");
    setColor(initial?.color || COLOR_OPTIONS[0]);
  }, [open, initial]);

  if (!open) return null;

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSave({ name: name.trim(), emoji, color, order: initial?.order ?? 0 });
  };

  return (
    <div className="modal-overlay" data-testid="category-editor-modal">
      <form onSubmit={submit} className="brutal-card p-6 w-full max-w-md">
        <div className="flex items-start justify-between mb-4">
          <h2 className="display text-2xl font-bold">
            {initial?.id ? "Edit category" : "New category"}
          </h2>
          <button type="button" className="pill-btn" onClick={onClose} data-testid="category-editor-close">
            <X size={18} />
          </button>
        </div>

        <label className="block mb-3">
          <span className="display font-semibold mb-1 block">Name</span>
          <input
            className="brutal-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            maxLength={40}
            placeholder="e.g. Snacks"
            data-testid="category-name-input"
          />
        </label>

        <div className="mb-3">
          <span className="display font-semibold mb-1 block">Symbol</span>
          <EmojiPicker value={emoji} onChange={setEmoji} />
        </div>

        <div className="mb-5">
          <span className="display font-semibold mb-1 block">Color</span>
          <div className="flex flex-wrap gap-2">
            {COLOR_OPTIONS.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setColor(c)}
                className={`w-10 h-10 rounded-full border-[3px] border-[color:var(--ink)] ${color === c ? "ring-4 ring-[color:var(--gold)]" : ""}`}
                style={{ background: c }}
                aria-label={`Color ${c}`}
                data-testid={`category-color-${c}`}
              />
            ))}
          </div>
        </div>

        <div className="flex gap-2 justify-end">
          <button type="button" className="pill-btn" onClick={onClose} data-testid="category-editor-cancel">
            Cancel
          </button>
          <button type="submit" className="pill-btn primary" data-testid="category-editor-save">
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
